const Header = () => {
  return (
    <header>
      <h1>Recipe-Finder</h1>
    </header>
  );
};
export default Header;
